/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AcceptAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import Tooltip from './Tooltip/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AcceptAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/AcceptAction",
  hovered,
  onMouseEnterManual,
  onMouseLeaveManual,
  isDisabled
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  hovered,
  onMouseEnterManual,
  onMouseLeaveManual,
  isDisabled
  
})
  return (<React.Fragment
>
<div
  data-testid="AcceptAction.Vertical"
  data-view-path={viewPath}
 hovered={hovered}
 onMouseEnter={onMouseEnterManual}
 onMouseLeave={onMouseLeaveManual}
 className={`views-block ${styles.Vertical}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 onClick={onClick}
 disabled={isDisabled}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Continue to contracts"
/>
)}
</TysiaButton>
<fromFlow.When is={isDisabled}>
<Tooltip
  viewPath={`${viewPath}/Tooltip`}
 flowNo={!hovered}
 flowContent={hovered}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}